import { ExpressionType } from '@framework/engine/schema/expressions/IExpression.ts';
import { getDefaultAssignableExpressionSchema } from '@framework/engine/schema/expressions/repository/assignable/AssignableExpressionSchema.ts';
import { ConditionGroupExpressionSchema } from '@framework/engine/schema/expressions/repository/condition-group/ConditionGroupExpressionSchema.ts';
import { ExpressionRepository } from '@framework/engine/schema/expressions/repository/ExpressionsRepository.ts';
import { CommonInputWidgetConfigSchema } from '@framework/engine/schema/widgets/repository/inputs/common/CommonInputConfigComponent.tsx';
import { yup } from '@framework/validation/initYup.ts';
import {
  type IModuleTriggerWidget,
  WidgetModuleTriggerType,
} from './IModuleTriggerWidget.ts';

export const ModuleTriggerConfigSchema: yup.ObjectSchema<IModuleTriggerWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetModuleTriggerType).required(),
    expression: ConditionGroupExpressionSchema.required().label('Espressione'),
    moduleId: yup.string().required().label('Modulo'),
    needUniqueModuleCode: yup
      .boolean()
      .required()
      .default(false)
      .label('Richiede codice univoco del widget'),
    uniqueModuleCode: getDefaultAssignableExpressionSchema(
      ExpressionRepository.get(ExpressionType.Value).schema.getDefault(),
    ),
    title: getDefaultAssignableExpressionSchema(
      ExpressionRepository.get(ExpressionType.Value).schema.getDefault(),
    ),
  })
    // uniqueModuleCode è un Lazy e yup dà problemi di tipo.
    // In questo modo possiamo andare a creare un when sul campo uniqueModuleCode
    // rimuovendolo quando non è necessario.
    .when('.', ([widget]: IModuleTriggerWidget[], schema) => {
      if (!widget) return schema;
      if (widget.needUniqueModuleCode) {
        return schema;
      }
      return schema.shape({
        uniqueModuleCode: yup.object().notRequired().strip(),
      });
    })
    .required()
    .noUnknown();
